import React, { useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import "@/App.css";
import { EnquiryProvider } from "@/context/EnquiryContext";
import Layout from "@/components/Layout";
import WireIntro from "@/components/WireIntro";
import Home from "@/pages/Home";
const Machines = React.lazy(() => import("@/pages/Machines"));
const Category = React.lazy(() => import("@/pages/Category"));
const Product = React.lazy(() => import("@/pages/Product"));
const About = React.lazy(() => import("@/pages/About"));
const CompanyProfile = React.lazy(() => import("@/pages/CompanyProfile"));
const ManufacturingFacility = React.lazy(() => import("@/pages/ManufacturingFacility"));
const WhyChooseUs = React.lazy(() => import("@/pages/WhyChooseUs"));
const Faq = React.lazy(() => import("@/pages/Faq"));
const Videos = React.lazy(() => import("@/pages/Videos"));
const NewsList = React.lazy(() => import("@/pages/NewsList"));
const NewsDetail = React.lazy(() => import("@/pages/NewsDetail"));
const BlogList = React.lazy(() => import("@/pages/BlogList"));
const BlogDetail = React.lazy(() => import("@/pages/BlogDetail"));
const Clients = React.lazy(() => import("@/pages/Clients"));
const Awards = React.lazy(() => import("@/pages/Awards"));
const Contact = React.lazy(() => import("@/pages/Contact"));
const MeasurementGuide = React.lazy(() => import("@/pages/MeasurementGuide"));
const PrivacyPolicy = React.lazy(() => import("@/pages/PrivacyPolicy"));
const Disclaimer = React.lazy(() => import("@/pages/Disclaimer"));
const ReturnRefund = React.lazy(() => import("@/pages/ReturnRefund"));
const NotFound = React.lazy(() => import("@/pages/NotFound"));
const AdminApp = React.lazy(() => import("@/pages/admin/AdminApp"));
import ErrorBoundary from "@/components/ErrorBoundary";

// Route-level boundary keyed by path so it resets on navigation and a malformed
// post can never produce a blank white page (shows a friendly message instead).
function RouteBoundary({ children }) {
  const { pathname } = useLocation();
  return <ErrorBoundary key={pathname}>{children}</ErrorBoundary>;
}

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function PublicSite() {
  return (
    <EnquiryProvider>
      <WireIntro />
      <Layout>
        <React.Suspense fallback={<div style={{ minHeight: "50vh" }} aria-label="Loading page" />}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/machines" element={<Machines />} />
          <Route path="/machines/:slug" element={<Category />} />
          <Route path="/products/:slug" element={<Product />} />
          <Route path="/about" element={<About />} />
          <Route path="/about/company-profile" element={<CompanyProfile />} />
          <Route path="/about/manufacturing" element={<ManufacturingFacility />} />
          <Route path="/about/why-choose-us" element={<WhyChooseUs />} />
          <Route path="/faq" element={<Faq />} />
          <Route path="/videos" element={<Videos />} />
          <Route path="/blog" element={<RouteBoundary><BlogList /></RouteBoundary>} />
          <Route path="/blog/:slug" element={<RouteBoundary><BlogDetail /></RouteBoundary>} />
          <Route path="/news" element={<RouteBoundary><NewsList /></RouteBoundary>} />
          <Route path="/news/:slug" element={<RouteBoundary><NewsDetail /></RouteBoundary>} />
          <Route path="/clients" element={<Clients />} />
          <Route path="/awards" element={<Awards />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/measurement-guide" element={<MeasurementGuide />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/disclaimer" element={<Disclaimer />} />
          <Route path="/return-refund-policy" element={<ReturnRefund />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        </React.Suspense>
      </Layout>
    </EnquiryProvider>
  );
}

function App() {
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path="/admin/*" element={<React.Suspense fallback={null}><AdminApp /></React.Suspense>} />
        <Route path="/*" element={<PublicSite />} />
      </Routes>
    </>
  );
}

export default App;
